import styled from "styled-components";
import { Link } from "gatsby";
import { palette } from "../../styles/global";
import { up, down, between, only } from 'styled-breakpoints';

type MobileMenuProps = {
  open: boolean
}

export const Wrapper = styled.div`
  z-index: 10;
  overflow: 'hidden';
  ${up('lg')}{
    display: none;
  }
`

export const LogoWrapper = styled.div`
  display:flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  transition: all 0.5s;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
`

export const Logo = styled.img`
  transition: all 0.5s;
  width: 150px;  
  width: 70px;
  margin-left: 2rem;
  margin-top: 1rem;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const MobileMenuWrapper = styled.nav<MobileMenuProps>`
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  flex-direction: column;
  background-color: #001273;
  color: ${palette.white};
  padding-top: 6rem;
  transition: all 0.3s linear;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`

export const BurgerWrapper = styled.div`
  border-top: 7px solid #1B78BC;  
  margin-right: 1rem;
  ${down('sm')}{
    margin-right: 0;
  }
  padding-right: 2rem;
  padding-left: 2rem;
  height: 53px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
`

export const StyledBurger = styled.button<MobileMenuProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  




  &:focus {
    outline: none;
  }

  
  div {
    width: 2rem;
    height: 0.25rem;
    background: ${props => props.open ? palette.white : '#000000'};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    z-index: 11;
    :first-child {
      transform: ${props => props.open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${props => props.open ? '0' : '1'};
    }

    :nth-child(3) {
      transform: ${props => props.open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
  
`;

type ItemWrapperProps = {
  color?: string
}

export const MobileMenuItemWrapper = styled.div<ItemWrapperProps>`
  background-color: ${props => props.color ? props.color : 'inherit'};
  padding: 3vh 0 3vh 0;
  text-align: center;
  font-weight: 300;
  font-size: 2rem;
  letter-spacing: 0px;
  z-index: 10;
  font-size: 200;
  color: ${props => props.color && props.color == '#ffffff' ? '#000000' : 'inherit'};
  line-height: 1.5;
`
